/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
// import 'react-bootstrap-typeahead/css/Typeahead-bs4.css';

const input = (props) => {
  let inputElement = null;

  switch (props.formcontrol) {
    case "input":
    default:
      inputElement = !props.formControlConfig.required ? (
        <div
          className="form-group form-material floating"
          data-plugin="formMaterial"
        >
          <input
            className="form-control empty"
            {...props.formControlConfig}
            value={props.value}
            onChange={props.changed}
          />
          <label
            className="floating-label"
            htmlFor={props.formControlConfig.id}
          >
            {props.formControlConfig.id}
          </label>
        </div>
      ) : (
        <div className="form-group form-material">
          <label className="col-xl-12 col-md-3 form-control-label">
            {props.formControlConfig.id}
            &nbsp;
            <span className="required">*</span>
          </label>
          <div className="col-xl-12 col-md-9" style={{ paddingLeft: "0rem" }}>
            <input
              className="form-control"
              {...props.formControlConfig}
              value={props.value}
              onChange={props.changed}
            />
          </div>
        </div>
      );
      break;
    case "search":
      inputElement = (
        <Typeahead
          id="Search"
          onChange={(selected) => props.searchHandler(selected)}
          options={props.options}
          clearButton
          placeholder={props.placeholder}
        />
      );
      break;
    case "select":
      inputElement = (
        <div
          className="form-group form-material floating"
          data-plugin="formMaterial"
        >
          <select
            className="form-control empty"
            id={props.formControlConfig.id}
            value={props.value}
            onChange={props.changed}
          >
            <option value=""></option>
            {props.formControlConfig.options.map((option) => {
              return (
                <option key={option.id} value={option.value}>
                  {option.id}
                </option>
              );
            })}
          </select>
          <label
            className="floating-label"
            htmlFor={props.formControlConfig.id}
          >
            {props.formControlConfig.id}
          </label>
        </div>
      );
      break;
    case "multiselect":
      inputElement = (
        <div className="form-group form-material" data-plugin="formMaterial">
          <label className="form-control-label" for="selectMulti">
            Multi Select
          </label>
          <select className="form-control" id="selectMulti" multiple="">
            <option>&nbsp;</option>
            {props.formControlConfig.options.map((option) => {
              return (
                <option key={option.id} value={option.value}>
                  {option.id}
                </option>
              );
            })}
          </select>
        </div>
      );
      break;
    case "checkbox":
      inputElement = (
        <div className="checkbox-custom checkbox-primary">
          <input
            {...props.formControlConfig}
            value={props.value}
            onChange={props.changed}
          />
          <label htmlFor={props.formControlConfig.id}>
            {props.formControlConfig.id}
          </label>
        </div>
      );
      break;
    case "radio":
      inputElement = (
        <div className="radio-custom radio-primary">
          <input
            {...props.formControlConfig}
            value={props.value}
            onChange={props.changed}
          />
          <label htmlFor={props.formControlConfig.id}>
            {props.formControlConfig.id}
          </label>
        </div>
      );
      break;
    case "textarea":
      inputElement = (
        <div
          className="form-group form-material floating"
          data-plugin="formMaterial"
        >
          <textarea
            className="form-control empty"
            rows="3"
            name="textareaFloating"
          ></textarea>
          <label className="floating-label">{props.formControlLabel}</label>
        </div>
      );
      break;
    case "datepicker":
      inputElement = (
        <div
          className="form-group form-material floating"
          data-plugin="formMaterial"
        >
          <input
            className="form-control"
            data-plugin="datepicker"
            {...props.formControlConfig}
            value={props.value}
            onChange={props.changed}
          />
          <label
            className="floating-label"
            htmlFor={props.formControlConfig.id}
          >
            {props.formControlConfig.id}
          </label>
        </div>
      );
      break;
    case "colorpicker":
      inputElement = (
        <div
          className="form-group form-material floating"
          data-plugin="formMaterial"
        >
          <input
            className="asColorpicker form-control colorInputUi-input"
            data-plugin="asColorPicker"
            data-mode="simple"
            {...props.formControlConfig}
            value={props.value}
            onChange={props.changed}
          />
          <label
            className="floating-label"
            htmlFor={props.formControlConfig.id}
          >
            {props.formControlConfig.id}
          </label>
        </div>
      );
  }

  return inputElement;
};

export default input;
